import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import React from 'react';
import Typography from '@material-ui/core/Typography';

function VcamsRemoveDialog(props) {
  return (
    <Dialog fullWidth maxWidth={'xs'} open={props.open}>
      <DialogContent>
        <div className='infrastructure-expanded'>
          <div className='border'>
            <h2 className="margin-bottom-none">Remove VCAM</h2>
            <Typography>{'Are you sure want to delete selected virtual cameras?'}</Typography>
            <Typography color='primary'>
              All Data related to the virtual cameras will be permanently deleted.
            </Typography>
          </div>
        </div>
      </DialogContent>
      <DialogActions style={{flexDirection: 'row', justifyContent: 'space-between', padding: '8px 24px'}}>
        <Button variant="text" onClick={() => props.onCancel()}>
          Cancel
        </Button>
        <Button variant='contained' color='primary' onClick={() => props.onOk()}>
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default React.memo(VcamsRemoveDialog);
